import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';
import * as DOCUMENT_NAME from '../../constants/documentNames';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function getSingleLotHistory(lotId, callback) {
	firebaseRef
		.ref('/kavtek_timestamps/' + projectCode + '/siteplan/lotInformation')
		.orderByChild('lotId')
		.equalTo(lotId)
		.on('value', async (snapshot) => {
			let historyObj = snapshot.val();
			let historyArr = [];
			if (historyObj) {
				for (let history of Object.values(historyObj)) {
					let userName = '';
					await firebaseRef
						.ref('users/' + history.alteredBy)
						.once('value', (snapshot) => {
							let user = snapshot.val();
							if (user?.fullName) {
								userName = user.fullName;
							}
						});

					historyArr.push({
						...history,
						alteredByName: userName,
					});
				}
			}
			historyArr.sort((a, b) => b.timestamp - a.timestamp);
			callback(historyArr);
		});
}

export async function getMultipleLotsHistory(lotIdArr, callback) {
	firebaseRef
		.ref('/kavtek_timestamps/' + projectCode + '/siteplan/lotInformation')
		.on('value', async (snapshot) => {
			let historyObj = snapshot.val();
			let historyArr = [];
			if (historyObj) {
				let filteredHistory = Object.values(historyObj).filter(
					(history) => lotIdArr.includes(history.lotId)
				);
				for (let history of filteredHistory) {
					if (history.alteredBy) {
						let userName = '';
						await firebaseRef
							.ref('users/' + history.alteredBy)
							.once('value', (snapshot) => {
								let user = snapshot.val();
								if (user?.fullName) {
									userName = user.fullName;
								}
							});

						historyArr.push({
							...history,
							alteredByName: userName,
						});
					}
				}
			}
			historyArr.sort((a, b) => b.timestamp - a.timestamp);
			callback(historyArr);
		});
}

export async function getSingleLotStatusHistory(lotId, callback) {
	firebaseRef
		.ref('/kavtek_agreements/' + projectCode + '/')
		.orderByChild('/productAvailability/lotId')
		.equalTo(lotId)
		.on('value', async (snapshot) => {
			let lotStatusHistory = [];
			let agreementsObj = snapshot.val();
			if (agreementsObj) {
				let agreementKeyArr = Object.keys(agreementsObj);
				for (let agreementKey of agreementKeyArr) {
					let agreement = agreementsObj[agreementKey];

					// get sales agent info
					let salesAgentId = '';
					let salesAgentName = '';
					let clientName = '';

					await firebaseRef
						.ref('kavtek_purchasers/' + projectCode)
						.once('value', (snapshot) => {
							let purchaserObj = snapshot.val();
							for (let purchaserKey in purchaserObj) {
								if (purchaserObj[purchaserKey][agreementKey]) {
									salesAgentId = purchaserKey;
									clientName =
										purchaserObj[purchaserKey][agreementKey]
											.clientFName +
										' ' +
										purchaserObj[purchaserKey][agreementKey]
											.clientLName;
								}
							}
						});
					if (salesAgentId) {
						await firebaseRef
							.ref('kavtek_sales_agents/' + projectCode)
							.orderByChild('createrID')
							.equalTo(salesAgentId)
							.once('value', (snapshot) => {
								let salesAgents = snapshot.val();
								if (salesAgents) {
									salesAgentName =
										Object.values(salesAgents)[0].name;
								}
							});
					}

					// the lot was sold
					if (
						agreement?.documentInformation?.coolingPeriodEnd &&
						agreement?.documentInformation?.coolingPeriodEnd <
							Date.now()
					) {
						lotStatusHistory.push({
							lotId: lotId,
							status: 'Sold',
							price: agreement?.productAvailability?.lotPrice,
							timestamp: new Date(
								agreement?.documentInformation?.coolingPeriodStart
							).getTime(),
							salesAgentId: salesAgentId,
							salesAgentName: salesAgentName,
							clientName: clientName,
						});
					}

					// the lot was canceled
					let signatureRequests =
						agreement?.documentInformation?.signatureRequests;
					if (signatureRequests) {
						for (let signatureRequestKey in signatureRequests) {
							if (
								signatureRequests[signatureRequestKey]
									.subject === DOCUMENT_NAME.aps
							) {
								let signatureUpdates =
									signatureRequests[signatureRequestKey]
										?.signatureUpdates;
								if (signatureUpdates) {
									for (let signatureUpdateKey in signatureUpdates) {
										if (
											signatureUpdates[signatureUpdateKey]
												?.event?.event_type ===
											'signature_request_canceled'
										) {
											lotStatusHistory.push({
												lotId: lotId,
												status: 'Cancelled',
												price: agreement
													?.productAvailability
													?.lotPrice,
												timestamp:
													signatureUpdates[
														signatureUpdateKey
													]?.event?.event_time * 1000,
												salesAgentId: salesAgentId,
												salesAgentName: salesAgentName,
												clientName: clientName,
											});
										}
									}
								}
							}
						}
					}

					// the lot is pending
					if (signatureRequests) {
						for (let signatureRequestKey in signatureRequests) {
							if (
								signatureRequests[signatureRequestKey]
									.subject === DOCUMENT_NAME.aps
							) {
								lotStatusHistory.push({
									lotId: lotId,
									status: 'Pending',
									price: agreement?.productAvailability
										?.lotPrice,
									timestamp:
										signatureRequests[signatureRequestKey]
											.timestamp,
									salesAgentId: salesAgentId,
									salesAgentName: salesAgentName,
									agreementKey: agreementKey,
									clientName: clientName,
								});
							}
						}
					}
				}
			}
			lotStatusHistory.sort((a, b) => b.timestamp - a.timestamp);
			callback(lotStatusHistory);
		});
}

export async function getSingleElevationHistory(
	buildingId,
	elevationId,
	callback
) {
	firebaseRef
		.ref(
			'/kavtek_timestamps/' +
				projectCode +
				'/siteplan/buildingInformation'
		)
		.on('value', async (snapshot) => {
			let historyObj = snapshot.val();
			let historyArr = [];
			if (historyObj) {
				let filteredHistory = Object.values(historyObj).filter(
					(history) =>
						buildingId === history.buildingId &&
						elevationId === history.elevationId
				);
				for (let history of filteredHistory) {
					let userName = '';
					await firebaseRef
						.ref('/users/' + history.alteredBy)
						.once('value', (snapshot) => {
							if (snapshot.val()) {
								userName = snapshot.val().fullName;
							}
						});
					historyArr.push({
						...history,
						alteredByName: userName,
					});
				}
			}
			historyArr.sort((a, b) => b.timestamp - a.timestamp);
			callback(historyArr);
		});
}

export async function getMultipleElevationsHistory(buildingId, callback) {
	firebaseRef
		.ref(
			'/kavtek_timestamps/' +
				projectCode +
				'/siteplan/buildingInformation'
		)
		.on('value', async (snapshot) => {
			let historyObj = snapshot.val();
			let historyArr = [];
			if (historyObj) {
				let filteredHistory = Object.values(historyObj).filter(
					(history) => buildingId === history.buildingId
				);
				for (let history of filteredHistory) {
					let userName = '';
					await firebaseRef
						.ref('/users/' + history.alteredBy)
						.once('value', (snapshot) => {
							if (snapshot.val()) {
								userName = snapshot.val().fullName;
							}
						});

					historyArr.push({
						...history,
						alteredByName: userName,
					});
				}
			}
			historyArr.sort((a, b) => b.timestamp - a.timestamp);
			callback(historyArr);
		});
}
